import * as thousandsAdvanced from './number'

// 合并所有过滤器
const filters = {
  ...thousandsAdvanced
}

/**
 * 安装过滤器到Vue实例
 * @param {Vue} Vue - Vue构造函数
 */
export function installFilters(Vue) {
  Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
  })
}

// 导出所有过滤器，方便按需引入
export {thousandsAdvanced}
export default filters


// WEBPACK FOOTER //
// ./src/filters/index.js